import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { STARKLINGS } from "@js/components/EducationCourse/eduConfig";
import { CardActionArea, Theme } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useTheme } from "@mui/material";
import { CustomThemeOptions } from "@js/components/CustomColors/Colors";
import { useRouter } from "next/router";

interface CourseCardProps {
    name: string;
    numModules: number;
    imgSrc: string;
    path: string;
    colorTheme: string;
}

const CourseCard: React.FC<CourseCardProps> = ({
    name,
    numModules,
    imgSrc,
    path,
    colorTheme,
}) => {
    const theme: CustomThemeOptions & Theme = useTheme();
    const router = useRouter();

    /**
     * Renders banner for OnlyDust on course card
     * @returns jsx
     */
    const renderOnlyDustBanner = () => {
        return (
            <div
                style={{
                    fontWeight: "lighter",
                    position: "absolute",
                    top: "8px",
                    right: "0",
                    width: "100%",
                    textAlign: "center",
                    zIndex: "3",
                    color: "white",
                    background: "rgba(0,0,0,0.2)",
                }}
            >
                Presented by OnlyDust
            </div>
        );
    };

    return (
        <Card
            sx={{
                margin: "10px",
                maxWidth: 345,
                width: "300px",
                height: "240px",
                padding: "10px",
                position: "relative",
            }}
            onClick={() => router.push(path)}
        >
            {name.toLowerCase() === STARKLINGS ||
            name.toLowerCase() === "starklings 1.0" ? (
                renderOnlyDustBanner()
            ) : (
                <></>
            )}
            <CardActionArea>
                <div
                    style={{
                        width: "100%",
                        backgroundColor: colorTheme,
                        display: "flex",
                        justifyContent: "center",
                        height: "110px",
                        borderRadius: "5px",
                        alignItems: "center",
                    }}
                >
                    <CardMedia
                        component="img"
                        image={imgSrc}
                        alt="Cairo Mummies"
                        sx={{ height: "90%", width: "auto" }}
                    />
                </div>
                <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                        {name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {numModules} Modules
                        <KeyboardArrowRightIcon
                            sx={{
                                float: "right",
                                backgroundColor: colorTheme,
                                borderRadius: "4px",
                                color: theme.palette.secondary.main,
                            }}
                        />
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default CourseCard;
